<template>
  <transition name="slide-fade" mode="out-in">
    <div
      id="service"
      v-wechat-title="$route.meta.title"
      :class="vid == 28 || vid == 27 ? 'marg' : ''"
    >
      <van-nav-bar
        :title="name"
        fixed=""
        left-arrow
        @click-left="onClickLeft"
      />
      <div class="main">
        <div v-if="vid == 28 || vid == 27">
          <van-pull-refresh
            v-model="isLoading2"
            @refresh="onRefresh2"
            success-text="刷新成功"
          >
            <van-list
              v-model="loading2"
              :finished="finished2"
              finished-text="没有更多了"
              @load="onLoad2"
            >
              <!-- <div class="list"> -->
              <div
                class="list-item"
                v-for="(item, index) in news2"
                :key="index"
                @click="toInfo(item.id, 2)"
              >
                <div class="item-tit">
                  <div class="tit1">{{ item.title }}</div>
                  <div class="tit2">
                    <span class="span1">{{ item.source }}</span>
                    <span class="span2">{{ item.create_date }}</span>
                    <span class="span3">
                      <van-icon name="eye-o" size="14px" />
                      <span style="margin-left: 0.1rem">{{ item.view }}</span>
                    </span>
                  </div>
                </div>
                <div class="item-img">
                  <img src="@/assets/san.png" v-if="item.cover == ''" />
                  <img :src="item.cover" v-else />
                </div>
              </div>
              <!-- </div> -->
            </van-list>
          </van-pull-refresh>
        </div>
        <div v-else>
          <van-tabs v-model="active">
            <van-tab title="党务">
              <van-pull-refresh
                v-model="isLoading"
                @refresh="onRefresh"
                success-text="刷新成功"
              >
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <!-- <div class="list"> -->
                  <div
                    class="list-item"
                    v-for="(item, index) in news"
                    :key="index"
                    @click="toInfo(item.id, 1)"
                  >
                    <div class="item-tit">
                      <div class="tit1">{{ item.title }}</div>
                      <div class="tit2">
                        <span class="span1">{{ item.source }}</span>
                        <span class="span2">{{ item.create_date }}</span>
                        <span class="span3">
                          <van-icon name="eye-o" size="14px" />
                          <span style="margin-left: 0.1rem">{{
                            item.view
                          }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="item-img">
                      <img src="@/assets/san.png" v-if="item.cover == ''" />
                      <img :src="item.cover" v-else />
                    </div>
                  </div>
                  <!-- </div> -->
                </van-list>
              </van-pull-refresh>
            </van-tab>
            <van-tab title="村务">
              <van-pull-refresh
                v-model="isLoading2"
                @refresh="onRefresh2"
                success-text="刷新成功"
              >
                <van-list
                  v-model="loading2"
                  :finished="finished2"
                  finished-text="没有更多了"
                  @load="onLoad2"
                >
                  <!-- <div class="list"> -->
                  <div
                    class="list-item"
                    v-for="(item, index) in news2"
                    :key="index"
                    @click="toInfo(item.id, 2)"
                  >
                    <div class="item-tit">
                      <div class="tit1">{{ item.title }}</div>
                      <div class="tit2">
                        <span class="span1">{{ item.source }}</span>
                        <span class="span2">{{ item.create_date }}</span>
                        <span class="span3">
                          <van-icon name="eye-o" size="14px" />
                          <span style="margin-left: 0.1rem">{{
                            item.view
                          }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="item-img">
                      <img src="@/assets/san.png" v-if="item.cover == ''" />
                      <img :src="item.cover" v-else />
                    </div>
                  </div>
                  <!-- </div> -->
                </van-list>
              </van-pull-refresh>
            </van-tab>
            <van-tab title="财务">
              <van-pull-refresh
                v-model="isLoading3"
                @refresh="onRefresh3"
                success-text="刷新成功"
              >
                <van-list
                  v-model="loading3"
                  :finished="finished3"
                  finished-text="没有更多了"
                  @load="onLoad3"
                >
                  <!-- <div class="list"> -->
                  <div
                    class="list-item"
                    v-for="(item, index) in news3"
                    :key="index"
                    @click="toInfo(item.id, 3)"
                  >
                    <div class="item-tit">
                      <div class="tit1">{{ item.title }}</div>
                      <div class="tit2">
                        <span class="span1">{{ item.source }}</span>
                        <span class="span2">{{ item.create_date }}</span>
                        <span class="span3">
                          <van-icon name="eye-o" size="14px" />
                          <span style="margin-left: 0.1rem">{{
                            item.view
                          }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="item-img">
                      <img src="@/assets/san.png" v-if="item.cover == ''" />
                      <img :src="item.cover" v-else />
                    </div>
                  </div>
                  <!-- </div> -->
                </van-list>
              </van-pull-refresh>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { NavBar, Tab, Tabs, Icon, PullRefresh, List } from "vant";
import { getArticle } from "@/api/apiData";
import axios from "axios";

export default {
  components: {
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data() {
    return {
      active: 0,
      name: "",
      vid: 0,
      news: [],
      isLoading: false,
      totalPages: 1,
      padding: false,
      loading: false,
      finished: false,
      page: 0,
      news2: [],
      isLoading2: false,
      totalPages2: 1,
      padding2: false,
      loading2: false,
      finished2: false,
      page2: 0,
      news3: [],
      isLoading3: false,
      totalPages3: 1,
      padding3: false,
      loading3: false,
      finished3: false,
      page3: 0,
      type: 0,
    };
  },
  mounted() {
    var vid = this.$route.query.id;
    this.vid = vid;
    var name = this.$route.query.name;
    this.name = name;
  },
  //跳转之后的页面加上activated钩子
  activated() {
    // if (this.$route.params.flush === 'on') {
    //   this.getList() // 获取分页信息
    // }
    var vid = this.$route.query.id;
    this.vid = vid;
    var name = this.$route.query.name;
    this.name = name;
    this.onRefresh();
    this.onRefresh2();
    this.onRefresh3();
  },
  methods: {
    onClickLeft() {
      this.$router.push("/service");
    },
    toInfo(id, n) {
      // this.name = ''
      if (n == 1) {
        this.name = this.name + "党务";
      } else if (n == 2) {
        this.name = this.name + "村务";
      } else if (n == 3) {
        this.name = this.name + "财务";
      }
      this.$router.push({
        path: "/newsInfo",
        query: { id: id, name: this.name },
      });
    },
    // 下拉加载
    onLoad() {
      this.getNewsList();
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news = [];
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getNewsList();
      setTimeout(() => {
        that.refreshing = false;
        // Toast("刷新成功");
        that.isLoading = false;
      }, 1500);
    },
    getNewsList() {
      var that = this;
      var news = this.news;
      var page = this.page + 1;
      var totalPages = this.totalPages;
      var param = {
        channel_id: 6,
        village_id: that.vid,
        page: page,
        size: 20,
      };
      if (totalPages >= page) {
        axios
          .post(
            "https://mqzpower.ncscloudmedia.com/index.php/api/article/query",
            param
          )
          .then(function (response) {
            let res = response.data;
            if (res.code == 1) {
              if (res.data.list.length < 4) {
                that.padding = false;
              }
              that.page = page;
              that.news = news.concat(res.data.list);
              that.totalPages = Math.ceil(
                Number(res.data.total) / res.data.list.length
              );
              if (res.data.list.length == 0) {
                //数据请求成功 但是无数据
                that.finished = true;
                that.loading = false;
                return false;
              }
              if (that.news.length >= news.length) {
                // 数据请求成功后  停止加载状态
                setTimeout(() => {
                  that.loading = false;
                }, 1500);
              }
            } else {
              //登录失败
              // Toast(res.message);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        // getArticle(param).then((res) => {
        //   if (res.code == 1) {
        //     if (res.data.data.length < 4) {
        //       this.padding = false;
        //     }
        //     that.page = page;
        //     that.news = news.concat(res.data.data);
        //     that.totalPages = Math.ceil(
        //       Number(res.data.total) / res.data.data.length
        //     );
        //     if (res.data.data.length == 0) {
        //       //数据请求成功 但是无数据
        //       that.finished = true;
        //       that.loading = false;
        //       return false;
        //     }
        //     if (that.news.length >= news.length) {
        //       // 数据请求成功后  停止加载状态
        //       setTimeout(() => {
        //         that.loading = false;
        //       }, 1500);
        //     }
        //   } else {
        //     //登录失败
        //     // Toast(res.message);
        //   }
        // });
      } else {
        // 全部数据加载完毕
        that.finished = true;
      }
    },
    // 下拉加载
    onLoad2() {
      this.getNewsList2();
    },
    // 下拉刷新
    onRefresh2() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news2 = [];
      that.page2 = 0;
      that.totalPages2 = 1;
      that.loading2 = false;
      that.finished2 = false;
      that.getNewsList2();
      setTimeout(() => {
        that.refreshing2 = false;
        // Toast("刷新成功");
        that.isLoading2 = false;
      }, 1500);
    },
    getNewsList2() {
      var that = this;
      var news = this.news2;
      var page = this.page2 + 1;
      var totalPages = this.totalPages2;
      var param = {
        channel_id: 7,
        village_id: that.vid,
        page: page,
        size: 20,
      };
      if (totalPages >= page) {
        axios
          .post(
            "https://mqzpower.ncscloudmedia.com/index.php/api/article/query",
            param
          )
          .then(function (response) {
            let res = response.data;
            if (res.code == 1) {
              if (res.data.list.length < 4) {
                that.padding = false;
              }
              that.page2 = page;
              that.news2 = news.concat(res.data.list);
              that.totalPages2 = Math.ceil(
                Number(res.data.total) / res.data.list.length
              );
              if (res.data.list.length == 0) {
                //数据请求成功 但是无数据
                that.finished2 = true;
                that.loading2 = false;
                return false;
              }
              if (that.news2.length >= news.length) {
                // 数据请求成功后  停止加载状态
                setTimeout(() => {
                  that.loading2 = false;
                }, 1500);
              }
            } else {
              //登录失败
              // Toast(res.message);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        // 全部数据加载完毕
        that.finished2 = true;
      }
    },
    // 下拉加载
    onLoad3() {
      this.getNewsList3();
    },
    // 下拉刷新
    onRefresh3() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news3 = [];
      that.page3 = 0;
      that.totalPages3 = 1;
      that.loading3 = false;
      that.finished3 = false;
      that.getNewsList3();
      setTimeout(() => {
        that.refreshing3 = false;
        // Toast("刷新成功");
        that.isLoading3 = false;
      }, 1500);
    },
    getNewsList3() {
      var that = this;
      var news = this.news3;
      var page = this.page3 + 1;
      var totalPages = this.totalPages3;
      var param = {
        channel_id: 8,
        village_id: that.vid,
        page: page,
        size: 20,
      };
      if (totalPages >= page) {
        axios
          .post(
            "https://mqzpower.ncscloudmedia.com/index.php/api/article/query",
            param
          )
          .then(function (response) {
            let res = response.data;
            if (res.code == 1) {
              if (res.data.list.length < 4) {
                that.padding = false;
              }
              that.page3 = page;
              that.news3 = news.concat(res.data.list);
              that.totalPages3 = Math.ceil(
                Number(res.data.total) / res.data.list.length
              );
              if (res.data.list.length == 0) {
                //数据请求成功 但是无数据
                that.finished3 = true;
                that.loading3 = false;
                return false;
              }
              if (that.news3.length >= news.length) {
                // 数据请求成功后  停止加载状态
                setTimeout(() => {
                  that.loading3 = false;
                }, 1500);
              }
            } else {
              //登录失败
              // Toast(res.message);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        // 全部数据加载完毕
        that.finished3 = true;
      }
    },
  },
};
</script>
<style scoped>
#service {
  padding-top: 90px;
}
.list {
  overflow-y: scroll;
}
.list-item {
  display: flex;
  padding: 0.5rem 1.2rem;
  text-align: left;
  font-size: 0.9rem;
  background: white;
  border-bottom: solid 1px ghostwhite;
}
.item-tit {
  width: 70%;
  margin-right: 5%;
}
.tit1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.tit2 {
  margin-top: 0.8rem;
  font-size: 0.7rem;
}
.span1 {
  color: #ff1106;
}
.span2 {
  color: #bebebe;
}
.span3 {
  float: right;
  color: #bebebe;
  display: flex;
}
.item-img {
  width: 25%;
}
.item-img img {
  width: 100%;
  height: 4rem;
}
.marg {
  padding-top: 50px !important;
}
</style>


// WEBPACK FOOTER //
// src/page/news.vue